export const IOS_NOTCH_MARGIN = 20;
export const IOS_BOTTOM_MARGIN = 34;
export const TAB_BAR_HEIGHT = 48;
export const HEADER_HEIGHT = 70;